export default __webpack_public_path__ + "static/media/rnr-sports-table-8.9d666814.webp";